'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AlcProduct = exports.renderErrorMessage = exports.PURCHASED_SCHEDULE_ID_SESSION_KEY = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reduxForm = require('redux-form');

var _sagaTools = require('@classpass/saga-tools');

var _effects = require('redux-saga/effects');

var _Base = require('derivers/Base64');

var _Base2 = _interopRequireDefault(_Base);

var _validators = require('validators');

var _GoogleTagManager = require('components/GoogleTagManager/GoogleTagManager');

var _AddressValidator = require('components/AddressForm/AddressValidator');

var _bound = require('redux/saga/entities/bound');

var _Authentication = require('features/Login/Authentication.saga');

var _ClassNoLongerAvailable = require('features/Signup/components/ClassNoLongerAvailable');

var _cart = require('redux/modules/cart');

var _apiErrorCodes = require('constants/api-error-codes');

var _helpers = require('redux/saga/helpers');

var _localStorage = require('redux/saga/helpers/local-storage');

var _deep = require('helpers/deep');

var _multitrack = require('helpers/multitrack');

var _optimizely = require('helpers/optimizely');

var _utmValues = require('helpers/utmValues');

var _selectors = require('redux/saga/selectors');

var _StripeElementsPaymentForm = require('components/PaymentForm/StripeElementsPaymentForm');

var _FormAction = require('../FormAction');

var _BaseProduct2 = require('./BaseProduct');

var _Banners = require('../../Banners/Banners.reducer');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PURCHASED_SCHEDULE_ID_SESSION_KEY = exports.PURCHASED_SCHEDULE_ID_SESSION_KEY = 'alc.purchasedScheduleId';

var renderErrorMessage = exports.renderErrorMessage = function renderErrorMessage(schedule) {
  return _react2.default.createElement(_ClassNoLongerAvailable.ClassNoLongerAvailable, {
    venueAlias: schedule.venue.alias,
    classAlias: schedule.class.alias,
    scheduleId: schedule.id
  });
};

var phoneFieldsValidator = (0, _validators.validateFields)(_validators.phoneValidator, ['emergencyPhone']);
var requiredFieldsValidator = (0, _validators.validateFields)(_validators.requiredValidator, ['dob', 'emergencyName']);

var AlcProduct = exports.AlcProduct = function (_BaseProduct) {
  (0, _inherits3.default)(AlcProduct, _BaseProduct);

  function AlcProduct() {
    (0, _classCallCheck3.default)(this, AlcProduct);
    return (0, _possibleConstructorReturn3.default)(this, (AlcProduct.__proto__ || (0, _getPrototypeOf2.default)(AlcProduct)).apply(this, arguments));
  }

  (0, _createClass3.default)(AlcProduct, null, [{
    key: 'shouldActivate',
    value: function shouldActivate(params) {
      return !!params.encodedScheduleId;
    }
  }, {
    key: 'errorMessager',
    value: /*#__PURE__*/_regenerator2.default.mark(function errorMessager(err, _ref2) {
      var scheduleId = _ref2.scheduleId;
      var schedule;
      return _regenerator2.default.wrap(function errorMessager$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(err && (err.code === _apiErrorCodes.ERROR_RESERVATION_NO_SPOTS || err.code === _apiErrorCodes.ERROR_RESERVATION_WINDOW_CLOSED))) {
                _context.next = 5;
                break;
              }

              _context.next = 3;
              return (0, _effects.select)(_bound.scheduleById.data, scheduleId);

            case 3:
              schedule = _context.sent;
              return _context.abrupt('return', renderErrorMessage(schedule));

            case 5:
              _context.next = 7;
              return (0, _effects.call)(_BaseProduct2.BaseProduct.errorMessager, err);

            case 7:
              return _context.abrupt('return', _context.sent);

            case 8:
            case 'end':
              return _context.stop();
          }
        }
      }, errorMessager, this);
    })
  }, {
    key: 'loadSignupData',
    value: /*#__PURE__*/_regenerator2.default.mark(function loadSignupData(client, params) {
      return _regenerator2.default.wrap(function loadSignupData$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return (0, _effects.call)(AlcProduct.loadData, 'signup', client, params);

            case 2:
            case 'end':
              return _context2.stop();
          }
        }
      }, loadSignupData, this);
    })
  }, {
    key: 'loadPurchaseData',
    value: /*#__PURE__*/_regenerator2.default.mark(function loadPurchaseData(client, params) {
      var schedule, purchase, requirements, hasRequirements;
      return _regenerator2.default.wrap(function loadPurchaseData$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return (0, _effects.call)(AlcProduct.loadData, 'purchase', client, params);

            case 2:
              schedule = _context3.sent;
              purchase = (0, _deep.deepExtract)('availability.purchase', schedule);
              _context3.next = 6;
              return (0, _effects.put)((0, _cart.emptyCart)());

            case 6:
              if (purchase) {
                _context3.next = 10;
                break;
              }

              _context3.next = 9;
              return (0, _effects.all)([(0, _effects.put)((0, _Banners.addFailureNotification)(renderErrorMessage(schedule))), (0, _effects.spawn)(_multitrack.ga, 'Membership Purchase', 'alc_checkout_error_no_spots_per_purchase', '' + schedule.id)]);

            case 9:
              return _context3.abrupt('return');

            case 10:
              _context3.next = 12;
              return (0, _effects.all)([(0, _effects.put)((0, _cart.setCartCurrency)(purchase.currency)), (0, _effects.put)((0, _cart.addCartItem)('class', 'Class price', purchase.amount))]);

            case 12:
              requirements = schedule.venue.requirements.user;
              hasRequirements = (0, _keys2.default)(requirements).some(function (req) {
                return requirements[req];
              });

              if (!hasRequirements) {
                _context3.next = 17;
                break;
              }

              _context3.next = 17;
              return (0, _effects.spawn)(_multitrack.ga, 'Membership Purchase', 'alc_checkout_additional_info', [].concat((0, _toConsumableArray3.default)(requirements.address ? ['address', 'city', 'state', 'zip'] : []), (0, _toConsumableArray3.default)(requirements.date_of_birth ? ['birthday'] : []), (0, _toConsumableArray3.default)(requirements.emergency_contact ? ['emergency_contact'] : [])).join('; '), 0, { nonInteraction: true });

            case 17:
            case 'end':
              return _context3.stop();
          }
        }
      }, loadPurchaseData, this);
    })
  }, {
    key: 'loadData',
    value: /*#__PURE__*/_regenerator2.default.mark(function loadData(form, client, _ref3) {
      var encodedScheduleId = _ref3.encodedScheduleId;

      var scheduleId, _ref4, _ref5, schedule, msaList, msaId, msa;

      return _regenerator2.default.wrap(function loadData$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              scheduleId = _Base2.default.decodeNumber(encodedScheduleId);
              _context4.next = 3;
              return (0, _effects.all)([(0, _effects.call)(_sagaTools.fetchEntityIfNeeded, _bound.scheduleById, [client, scheduleId, { alc: true }]), (0, _effects.call)(_sagaTools.fetchEntityIfNeeded, _bound.msas, [client])]);

            case 3:
              _ref4 = _context4.sent;
              _ref5 = (0, _slicedToArray3.default)(_ref4, 2);
              schedule = _ref5[0];
              msaList = _ref5[1];
              msaId = schedule.venue.location.msa_id;
              msa = (0, _selectors.msaByIdentifier)(msaList, msaId);
              _context4.next = 11;
              return (0, _effects.all)([(0, _effects.put)((0, _reduxForm.change)(form, 'scheduleId', scheduleId)), (0, _effects.put)((0, _reduxForm.change)(form, 'msaId', msaId)), (0, _effects.put)((0, _reduxForm.change)(form, 'country', msa.country_code))]);

            case 11:
              _context4.next = 13;
              return (0, _effects.spawn)(_GoogleTagManager.trackGoogleTagManagerEvent, {
                scheduleId: scheduleId,
                msaId: msaId,
                msaName: msa.alias
              });

            case 13:
              return _context4.abrupt('return', schedule);

            case 14:
            case 'end':
              return _context4.stop();
          }
        }
      }, loadData, this);
    })
  }, {
    key: 'submitSignupData',
    value: /*#__PURE__*/_regenerator2.default.mark(function submitSignupData(client, basePayload, formData) {
      return _regenerator2.default.wrap(function submitSignupData$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return (0, _effects.call)(_Authentication.createUserAndLogIn, client, _FormAction.signup, (0, _extends3.default)({}, basePayload, {
                alc_schedule_id: formData.scheduleId
              }));

            case 2:
              return _context5.abrupt('return', _context5.sent);

            case 3:
            case 'end':
              return _context5.stop();
          }
        }
      }, submitSignupData, this);
    })
  }, {
    key: 'postPurchase',
    value: /*#__PURE__*/_regenerator2.default.mark(function postPurchase(result, _ref6) {
      var scheduleId = _ref6.scheduleId;

      var _ref7, _ref8, schedule;

      return _regenerator2.default.wrap(function postPurchase$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return (0, _effects.all)([(0, _effects.select)(_bound.scheduleById.data, scheduleId), (0, _effects.call)(AlcProduct.trackPurchaseSuccess, result, scheduleId), (0, _effects.call)(_localStorage.writeSessionStorage, PURCHASED_SCHEDULE_ID_SESSION_KEY, scheduleId)]);

            case 2:
              _ref7 = _context6.sent;
              _ref8 = (0, _slicedToArray3.default)(_ref7, 1);
              schedule = _ref8[0];
              _context6.next = 7;
              return (0, _effects.call)(_helpers.gtmSafeRedirect, '/classes/' + schedule.venue.alias + '/' + schedule.class.alias + '/' + scheduleId);

            case 7:
            case 'end':
              return _context6.stop();
          }
        }
      }, postPurchase, this);
    })
  }, {
    key: 'submitPurchaseData',
    value: /*#__PURE__*/_regenerator2.default.mark(function submitPurchaseData(client, currentUserId, _ref, consents) {
      var stripeTokenPromiseKey = _ref.stripeTokenPromiseKey,
          scheduleId = _ref.scheduleId,
          ccZip = _ref.ccZip,
          extraFormData = (0, _objectWithoutProperties3.default)(_ref, ['stripeTokenPromiseKey', 'scheduleId', 'ccZip']);

      var stripePromiseToCall, _ref9, _ref10, paymentToken, payload;

      return _regenerator2.default.wrap(function submitPurchaseData$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return (0, _effects.call)(_StripeElementsPaymentForm.getTokenPromise, stripeTokenPromiseKey);

            case 2:
              stripePromiseToCall = _context7.sent;
              _context7.next = 5;
              return (0, _effects.all)([(0, _effects.call)(stripePromiseToCall), (0, _effects.call)(AlcProduct.handleUserProfileData, client, extraFormData)]);

            case 5:
              _ref9 = _context7.sent;
              _ref10 = (0, _slicedToArray3.default)(_ref9, 1);
              paymentToken = _ref10[0];
              _context7.t0 = consents;
              _context7.t1 = paymentToken;
              _context7.next = 12;
              return (0, _effects.call)(_utmValues.getForApi);

            case 12:
              _context7.t2 = _context7.sent;
              _context7.t3 = scheduleId;
              _context7.t4 = {
                address: {
                  postal_code: String(ccZip)
                }
              };
              payload = {
                consents: _context7.t0,
                payment_token: _context7.t1,
                conversion: _context7.t2,
                alc_schedule_id: _context7.t3,
                billing_info: _context7.t4
              };
              _context7.prev = 16;
              _context7.next = 19;
              return (0, _effects.call)(client.users.purchaseALaCarte, payload);

            case 19:
              return _context7.abrupt('return', _context7.sent);

            case 22:
              _context7.prev = 22;
              _context7.t5 = _context7['catch'](16);
              _context7.t6 = _context7.t5.code;
              _context7.next = _context7.t6 === _apiErrorCodes.ERROR_PAYMENT ? 27 : _context7.t6 === _apiErrorCodes.ERROR_RESERVATION_NO_SPOTS ? 30 : _context7.t6 === _apiErrorCodes.ERROR_RESERVATION_WINDOW_CLOSED ? 33 : 36;
              break;

            case 27:
              _context7.next = 29;
              return (0, _effects.call)(_multitrack.ga, 'Membership Purchase', 'alc_checkout_error_payment_fail', scheduleId);

            case 29:
              return _context7.abrupt('break', 39);

            case 30:
              _context7.next = 32;
              return (0, _effects.call)(_multitrack.ga, 'Membership Purchase', 'alc_checkout_error_no_spots', scheduleId);

            case 32:
              return _context7.abrupt('break', 39);

            case 33:
              _context7.next = 35;
              return (0, _effects.call)(_multitrack.ga, 'Membership Purchase', 'alc_checkout_error_window_closed', scheduleId);

            case 35:
              return _context7.abrupt('break', 39);

            case 36:
              _context7.next = 38;
              return (0, _effects.call)(_multitrack.ga, 'Membership Purchase', 'alc_checkout_error_reservation_fail', scheduleId);

            case 38:
              return _context7.abrupt('break', 39);

            case 39:
              throw _context7.t5;

            case 40:
            case 'end':
              return _context7.stop();
          }
        }
      }, submitPurchaseData, this, [[16, 22]]);
    })
  }, {
    key: 'handleUserProfileData',
    value: /*#__PURE__*/_regenerator2.default.mark(function handleUserProfileData(client, _ref11) {
      var address1 = _ref11.address1,
          address2 = _ref11.address2,
          city = _ref11.city,
          state = _ref11.state,
          postalCode = _ref11.postalCode,
          dob = _ref11.dob,
          emergencyName = _ref11.emergencyName,
          emergencyPhone = _ref11.emergencyPhone;
      var hasAddress, hasDob, hasEmergency;
      return _regenerator2.default.wrap(function handleUserProfileData$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              hasAddress = !!(address1 || address2 || city || state || postalCode);
              hasDob = !!dob;
              hasEmergency = !!(emergencyName || emergencyPhone);

              if (!(hasAddress || hasDob || hasEmergency)) {
                _context8.next = 6;
                break;
              }

              _context8.next = 6;
              return (0, _effects.call)(client.users.updateUserProfile, (0, _extends3.default)({}, hasAddress && {
                contact_info: (0, _extends3.default)({}, hasAddress && {
                  address: {
                    address1: address1,
                    address2: address2,
                    city: city,
                    state: state,
                    postal_code: postalCode
                  }
                })
              }, hasDob && { date_of_birth: dob }, hasEmergency && {
                emergency_contact: {
                  name: emergencyName,
                  phone: emergencyPhone
                }
              }));

            case 6:
            case 'end':
              return _context8.stop();
          }
        }
      }, handleUserProfileData, this);
    })
  }, {
    key: 'trackPurchaseSuccess',
    value: /*#__PURE__*/_regenerator2.default.mark(function trackPurchaseSuccess(result, scheduleId) {
      var purchaseChargeAmount, currency, msaId, msaName, planCode, purchasePlanId, taxAmount, purchaseTransactionId, _ref12, klass;

      return _regenerator2.default.wrap(function trackPurchaseSuccess$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              purchaseChargeAmount = result.charge_amount, currency = result.currency_code, msaId = result.msa_id, msaName = result.msa_name, planCode = result.plan_code, purchasePlanId = result.plan_id, taxAmount = result.tax_amount, purchaseTransactionId = result.id;
              _context9.next = 3;
              return (0, _effects.select)(_bound.scheduleById.data, scheduleId);

            case 3:
              _ref12 = _context9.sent;
              klass = _ref12.class;
              _context9.t0 = _effects.all;
              _context9.t1 = _effects.call;
              _context9.t2 = _GoogleTagManager.trackGoogleTagManagerEvent;
              _context9.t3 = purchaseChargeAmount;
              _context9.t4 = currency;
              _context9.t5 = msaId;
              _context9.t6 = msaName;
              _context9.t7 = planCode;
              _context9.t8 = purchasePlanId;
              _context9.t9 = taxAmount;
              _context9.t10 = purchaseTransactionId;
              _context9.next = 18;
              return (0, _effects.select)(_selectors.userId);

            case 18:
              _context9.t11 = _context9.sent;
              _context9.t12 = klass.activities;
              _context9.t13 = {
                purchaseChargeAmount: _context9.t3,
                currency: _context9.t4,
                msaId: _context9.t5,
                msaName: _context9.t6,
                planCode: _context9.t7,
                purchasePlanId: _context9.t8,
                taxAmount: _context9.t9,
                purchaseTransactionId: _context9.t10,
                userId: _context9.t11,
                quantity: 1,
                category: _context9.t12,
                name: 'alc_purchase'
              };
              _context9.t14 = (0, _context9.t1)(_context9.t2, _context9.t13);
              _context9.t15 = (0, _effects.call)(_multitrack.ga, 'Membership Purchase', 'purchase_alc_success', scheduleId);
              _context9.t16 = (0, _effects.call)(_optimizely.trackOptimizelyEvent, 'successful_alc_purchase');
              _context9.t17 = (0, _effects.call)(_optimizely.trackOptimizelyEvent, 'successful_overall_purchase');
              _context9.t18 = [_context9.t14, _context9.t15, _context9.t16, _context9.t17];
              _context9.next = 28;
              return (0, _context9.t0)(_context9.t18);

            case 28:
            case 'end':
              return _context9.stop();
          }
        }
      }, trackPurchaseSuccess, this);
    })
  }]);
  return AlcProduct;
}(_BaseProduct2.BaseProduct);

AlcProduct.key = 'AlcProduct';
AlcProduct.pathAlias = 'class';

AlcProduct.validator = function (formData) {
  return (0, _assign2.default)({}, _BaseProduct2.BaseProduct.validator(formData), (0, _AddressValidator.addressValidator)(formData), phoneFieldsValidator(formData), requiredFieldsValidator(formData));
};